import React, {useEffect, useState} from "react";
import { Autocomplete, TextField } from "@mui/material";
import {produce} from "immer";
import {useDispatch, useSelector} from "react-redux";
import {getUoms, getUomsData, getUomsStatus} from "../../redux/ProductsSlice";

const UomAutocomplete = ({
                             id,
                             handleChangeFunction,
                             formSetter,
                             disabled,
                             initialValue,
                             required
                         }) => {
    const uoms = useSelector(getUomsData)
    const uomsStatus = useSelector(getUomsStatus);

    const dispatch = useDispatch();

    useEffect(() => {
        if (uomsStatus === 'idle') {
            dispatch(getUoms());
        }
    }, [dispatch, uomsStatus]);

    const uomOptions = Object.keys(uoms).flatMap(group =>
        uoms[group].map(option => ({ ...option, group }))
    );
    
    const [value, setValue] = useState(uomOptions.find(x => x.abbreviation === initialValue));
    
    const handleChange = (e, newValue) => {
        setValue(newValue);
        if (handleChangeFunction) {
            handleChangeFunction(id, newValue?.abbreviation);
        } else {
            formSetter(produce((draft) => {
                draft.uom = newValue?.abbreviation;
            }));
        }
    };

    return (
        <Autocomplete
            id={`${id}-uom`}
            options={uomOptions}
            groupBy={(option) => option.group}
            getOptionLabel={(option) => option.unit || ''}
            onChange={handleChange}
            value={value || null}
            disabled={disabled}
            isOptionEqualToValue={(option, value) => option.abbreviation === value?.abbreviation}
            noOptionsText="No options found."
            loading={uomsStatus === 'loading'}
            fullWidth
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Unit of Measure"
                    required={required}
                    disabled={disabled}
                />
            )}
        />
    );
};

export default UomAutocomplete;